import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7becdb43"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mx-auto wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("再享 InvestNFT & 元富雙重賦能");

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-landing-title lh-base"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-white font-h5 lh-base"
}, "持有 NFT 享有多重通路優惠")], -1));

const _hoisted_4 = {
  class: "card-list d-flex flex-wrap"
};
const _hoisted_5 = {
  class: "link-wrapper"
};
const _hoisted_6 = ["href"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-white"
}, ">", -1));

import feature7 from "@/assets/master-link/feature-7.png";
import feature8 from "@/assets/master-link/feature-8.png";
export default {
  __name: 'InvestAndMasterLinkBenefitsBlock',

  setup(__props) {
    const list = [{
      image: feature7,
      title: 'NFT 內含最低價值與流通性',
      desc: '套用投資型內含價值，並為以太鏈 NFT，可流通於全球最大交易平台OpenSea。',
      more: 'https://discord.gg/3Z7Y4Y2'
    }, {
      image: feature8,
      title: '元富交易手續費全年 28 折',
      desc: '享有一年期元富交易手續費2.8折扣優惠，自xxxx年xx月xx日至xxxx年xx月xx日止。',
      more: 'https://discord.gg/3Z7Y4Y2'
    }];
    return (_ctx, _cache) => {
      const _component_landing_title = _resolveComponent("landing-title");

      const _component_feature_badge_card = _resolveComponent("feature-badge-card");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "card-wrapper"
        }, [_createVNode(_component_feature_badge_card, {
          badgeUrl: item.image
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          desc: _withCtx(() => [_createTextVNode(_toDisplayString(item.desc) + " ", 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
            class: "text-white me-2",
            href: item.more
          }, "了解詳情", 8, _hoisted_6), _hoisted_7])]),
          _: 2
        }, 1032, ["badgeUrl"])]);
      }), 64))])]);
    };
  }

};